import React from 'react';
import MultistoreOrderingStep from "./MultistoreOrderingStep";
import {useTranslation} from "react-i18next";
import {ConfigApi, PlaceApi} from "../../../../../../../services/Api/types";
import {ReactComponent as TpayIco} from "../../../../../../../../images/icons/payments/tpay.svg";
import {ReactComponent as ApplePayIco} from "../../../../../../../../images/icons/payments/applepay.svg";
import {ReactComponent as GooglePayIco} from "../../../../../../../../images/icons/payments/googlepay.svg";
import {ReactComponent as BlikIco} from "../../../../../../../../images/icons/payments/blik.svg";
import StoreUtils from "../../../../../../../services/Store/StoreUtils";
import {SessionState} from "../../../../../../../services/Session/types";

interface Props {
    places: PlaceApi[];
    session: SessionState;
    config: ConfigApi;
}

const MultistoreOrderingSteps = ({places, config, session}: Props) => {
    const {t} = useTranslation();

    if (StoreUtils.isOrderingReadonly(config) || !StoreUtils.isQrcodeContext(session)) return <></>;

    const drawFirstStep = () => {
        const placesWithLogo = places.filter(place => place.logo_small);

        const content = placesWithLogo.length === 0 ? undefined : (
            <div className="img-elements-container">
                {placesWithLogo.map(place => (
                    <div className="img-element-container" key={place.domain}>
                        <div className="img" style={{backgroundImage: `url("${place.logo_small}")`}}/>
                    </div>
                ))}
            </div>
        );

        return (
            <MultistoreOrderingStep step={1} title={t("modules.multistore.field.choose_store.title")}
                                    content={content}/>
        );
    }

    const drawThirdStep = () => {
        const paymentMethods = [{
            id: "BLIK",
            svg: <BlikIco/>
        },
            {
                id: "APPLE_PAY",
                svg: <ApplePayIco/>
            },
            {
                id: "GOOGLE_PAY",
                svg: <GooglePayIco/>
            },
            {
                id: "TPAY",
                svg: <TpayIco/>
            },
        ]

        const content = (
            <div className="payment-methods-container">
                {paymentMethods.map(paymentMethod => (
                    <div className="payment-method" key={paymentMethod.id}>
                        {paymentMethod.svg}
                    </div>
                ))}
            </div>
        );

        return (
            <MultistoreOrderingStep step={3} title={t("modules.multistore.field.pay_comfortably.title")}
                                    content={content}/>
        );
    }

    return (
        <div className="multistore-ordering-steps">
            {drawFirstStep()}
            <MultistoreOrderingStep step={2} title={t("modules.multistore.field.place_an_order.title")}/>
            {drawThirdStep()}
            <MultistoreOrderingStep step={4} title={t("modules.multistore.field.pick_up_at_store.title")}/>
        </div>
    )
}

export default MultistoreOrderingSteps;